const FullPageLoader = () => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 9999, top: 0, left: 0 }}
    >
      <div className="bg-white p-4 rounded shadow text-center">
        <h3 className="mb-4 text-secondary">Loading...</h3>
        <div className="d-flex justify-content-center gap-3">
          {[...Array(3)].map((_, idx) => (
            <div
              key={idx}
              className="spinner-grow text-danger"
              role="status"
              style={{ width: '1.2rem', height: '1.2rem' }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FullPageLoader;
